import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12m20 0c0-5.1-4.15-9.25-9.25-9.25S2.75 6.9 2.75 12 6.9 21.25 12 21.25s9.25-4.15 9.25-9.25" }),
      _createElementVNode("path", { d: "M11.25 15.5v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75" }),
      _createElementVNode("path", { d: "M8.25 11.5c0-.19.07-.38.22-.53l3-3c.29-.29.77-.29 1.06 0l3 3c.29.29.29.77 0 1.06s-.77.29-1.06 0L12 9.56l-2.47 2.47c-.29.29-.77.29-1.06 0a.74.74 0 0 1-.22-.53" })
    ], -1)
  ]))]))
}
export default { render: render }